import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// tslint:disable-next-line:max-line-length
import { PredefinedQuery, PredefinedQueryDetail, PredefinedQueryRequest, PredefinedQueryVariable, QueryResultatsResponse } from './predefined-queries.models';

@Injectable({
  providedIn: 'root'
})
export class PredefinedQueriesService {
  private apiUrl: string;

  constructor(private _http: HttpClient,
              private _appConfig: AppConfigService) {
    this.apiUrl = _appConfig.config.servicesBaseUrl;
  }

  getQueries(): Observable<PredefinedQuery[]> {
    return this._http.get<PredefinedQuery[]>(this.apiUrl + `/adm/queries`);
  }

  getQueryDetail(queryId: string): Observable<PredefinedQuery> {
    return this._http.get<PredefinedQuery>(this.apiUrl + `/adm/queries/` + queryId);
  }

  executeQueryWithVariable(variables: PredefinedQueryRequest, page?: number, pageSize?: number): Observable<QueryResultatsResponse> {
    let query = this.apiUrl + `/adm/queries/execute`;
    if ( page !== undefined && pageSize !== undefined) {
      query += '?page=' + page + '&itemsByPage=' + pageSize;
    }
    return this._http.post<QueryResultatsResponse>(query, variables);
  }

  getQueryVariables(queryId: string): Observable<PredefinedQueryVariable[]> {
    return this._http.get<PredefinedQueryVariable[]>(this.apiUrl + `/adm/queries/` + queryId + `/variables`);
  }

  exportExcel(variables: PredefinedQueryRequest)  {
    return this._http.post<any>( this.apiUrl + `/adm/queries/export`, variables,
        {
          responseType: 'blob' as 'json',
          observe: 'response'
        });
  }

}
